import React from 'react'
import { dialogTypes } from '@/dialogs'
import { getStore } from '@/store'
import { headerTypes } from '../enums/headerTypes'
import { definitionType } from '@/enums/definitionType'
import { getExistingUserRowCodes } from '@/store/utils/reportUtils'
import { localized } from '@/decorators/localized'

// Can't connect these, importing instead
import { actionCreators as dialogActions } from '@/store/Dialogs'
import { actionCreators } from '@/store/ReportSubmissions'
import { getPureMetadata, preventAndStop } from '../core/utils'

@localized()
class UserRowEditorRenderer extends React.Component {
  deleteItem () {
    getStore().dispatch(actionCreators.deleteUserRow({ ...getPureMetadata(this.props) }, this.props.row - 1))
  }

  onRemove = (e) => {
    e.preventDefault()
    e.stopPropagation()
    getStore().dispatch(dialogActions.openDialog({
      dialogType: dialogTypes.confirm,
      title: 'Common.DeleteDialogTitle',
      content: 'Common.DeleteDialogText',
      onAction: () => this.deleteItem()
    }))
  }

  editItem (value, latinValue) {
    getStore().dispatch(actionCreators.updateUserRow({
      ...getPureMetadata(this.props),
      name: value,
      latinName: latinValue,
      isUserRow: true,
      definitionType: definitionType.enum.Normal,
      parent: null,
      headerRenderer: null,
      type: headerTypes.Classic,
      row: this.props.row
    }))
  }

  onEdit = (e) => {
    e.preventDefault()
    e.stopPropagation()
    const store = getStore()
    const state = store.getState()

    const item = getPureMetadata(this.props)
    const existingCodes = getExistingUserRowCodes(state.reportSubmissions.userDefCodes, this.props.parentId)

    store.dispatch(dialogActions.openDialog({
      existingCodes: existingCodes && existingCodes.length
        ? existingCodes.filter(x => x !== item.code)
        : existingCodes,
      dialogType: dialogTypes.userRow,
      value: item.name,
      latinValue: item.name === item.latinName
        ? null : item.latinName,
      onAction: value => this.editItem(value.value, value.latinValue)
    }))
  }

  render () {
    const name = this.props.localizeValue(this.props.name, this.props.latinName)
    const fromDefinitionType = this.props.fromDefinitionType

    return <div>
      <button onMouseDown={preventAndStop} onClick={this.onRemove}><i className='bx bx-trash' /></button>
      { fromDefinitionType === definitionType.enum.UserDef && <button onMouseDown={preventAndStop} onClick={this.onEdit}><i className='bx bx-pencil' /></button>}
      {name}
    </div>
  }
}

export { UserRowEditorRenderer }



// WEBPACK FOOTER //
// ./src/components/report-tables/headers/userRowEditorRenderer.js